var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFormatPaint = function SvgFormatPaint(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11 15v-2a1 1 0 0 1 1-1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-2m-1.225 3H4.225A1.224 1.224 0 0 1 3 7.775v-3.55C3 3.548 3.548 3 4.225 3h12.551C17.452 3 18 3.548 18 4.225v3.551C18 8.452 17.452 9 16.775 9ZM12 22h-2a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFormatPaint);
export default ForwardRef;